import { useTheme } from "@mui/material"
import React from "react"
import { useMediaQuery } from "react-responsive"
import { useNavigate } from "react-router-dom"

import { Box, Image, Typography } from "src/UILibrary"
import { ArrowRightIcon } from "src/UILibrary/icons/ArrowRightIcon"
import "./incubation_item.scss"

export const IncubationCafeItem = ({
  image,
  title,
  to,
  newTab,
}: {
  image: string
  title: string
  to: string
  newTab?: boolean
}) => {
  const theme = useTheme()

  const navigate = useNavigate()

  const isPC = useMediaQuery({ query: "(min-width: 1050px)" })

  return (
    <Box sx={{ bgcolor: "background.default" }} className="incubation-container">
      <Image
        src={image}
        sx={{
          bgcolor: "divider",
          ":hover": { opacity: 0.8, cursor: "pointer" },
          ...(isPC ? { height: "200px" } : { maxWidth: "100%", maxHeight: "260px" }),
        }}
        alt=""
        imageStyle={{ width: "100%", height: "100%" }}
        onClick={() => (newTab ? window.open(to, "_blank") : navigate(to))}
      />
      <Box display="flex" width="100%" sx={{ ":hover": { opacity: 0.8, cursor: "pointer" } }}>
        <Typography.CardHead
          color="textPrimary"
          mt="20px"
          mr="auto"
          className="incubation-title"
          fontSize={22}
          onClick={() => (newTab ? window.open(to, "_blank") : navigate(to))}
        >
          {title}
        </Typography.CardHead>
        <ArrowRightIcon
          color={theme.palette.text.primary}
          width="13"
          height="26"
          sx={{ height: "20px", mt: "auto" }}
        />
      </Box>
    </Box>
  )
}
